module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("CHAPTER 1: Christ Before Time")]), _vm._v(" "), _c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "CHAPTER 1: Christ Before Time"
    }
  }, [_c('h1', {
    staticClass: "ctl",
    attrs: {
      "id": "p0025-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/chapter2#cha1",
      "id": "cccc1"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "txll"
  }, [_vm._v("..............................................................................")]), _vm._v(" "), _c('p', {
    staticClass: "ct11"
  }, [_c('span', [_c('em', [_c('a', {
    attrs: {
      "href": "#/chapter2#cha1"
    }
  }, [_vm._v("Christ Before Time ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "extb",
    attrs: {
      "id": "p0025-02-1"
    }
  }, [_c('span', [_c('em', [_vm._v("Every word of the God-breathed character of "), _c('br'), _vm._v(" Scripture is meaningless if Holy Scripture is not "), _c('br'), _vm._v(" understood as the witness concerning Christ.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx3",
    attrs: {
      "id": "p0025-03-3"
    }
  }, [_c('span', [_vm._v("—G. C. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERKOUWER")]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus1",
      "id": "car1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0025-04-4"
    }
  }, [_c('span', [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CRIPTURE "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("FINDS")]), _vm._v(" ITS "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("ORGANIC")]), _vm._v(" CENTER "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("AND")]), _vm._v(" UNITY IN")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESUS")]), _vm._v(". For this reason, the biblical narrative has its beginning in the creation of the universe through Christ, its middle in the earthly life and ministry of Christ, and its end in the reconciliation of all things in Christ. There’s an overarching unity to both Testaments. And Christ is the unifying agent.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-05-6"
    }
  }, [_c('span', [_vm._v("Part of that statement is not entirely accurate. While Genesis begins the scriptural narrative at the point of creation, the Second Testament tells us that the narrative actually begins somewhere else. The Jesus story doesn’t begin in Bethlehem, Nazareth, or even Israel. According to the Second Testament, it begins long before them. It begins in the dateless past, before angels or atoms.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-06-8"
    }
  }, [_c('span', [_vm._v("In this chapter, we will narrate the Jesus story as it happened before creation, and we will get a breathtaking glimpse of the preincarnate "), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v(" Christ—the eternal Son, the preexistent Word, Jesus before time, Christ before creation.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  })]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-02-2"
    }
  }, [_c('span', [_vm._v("The Second Testament contains numerous texts that give us insight into Christ before time. And the First Testament supports those texts.")])])]), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_01",
      "role": "doc-chapter",
      "title": "BEFORE THE FOUNDATION OF THE WORLD"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "P0026-03-4"
    }
  }, [_c('span', [_vm._v("BEFORE THE FOUNDATION OF THE WORLD ")])])]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0026-04-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("Considering Jesus before the world began is mind-boggling. We feel we are fumbling in the dark, groping for words to express the inexpressible. It’s impossible to find adequate language for what happened before creation. Taken literally, "), _c('em', [_vm._v("before creation ")]), _vm._v("is unintelligible because there is no such thing as a “before” or an “after” until there is a creation. According to Einstein’s physics, time doesn’t exist without mass and matter. Time, therefore, begins with creation.")])]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus2",
      "id": "car2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-05-6"
    }
  }, [_c('span', [_vm._v("So on a literal basis, phrases like "), _c('em', [_vm._v("time before time ")]), _vm._v("or "), _c('em', [_vm._v("before creation ")]), _vm._v("are nonsensical. They only make sense when we see them as intuitively graspable metaphors. When we talk about what God was doing before creation, it’s impossible to avoid language that sounds as though we are talking about a time before time."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus3",
      "id": "car3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Nonetheless, we will use these metaphors because Scripture uses them. The phrases “before the foundation of the world” and “before the world began” are used frequently in the Second Testament."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus4",
      "id": "car4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-06-7"
    }
  }, [_c('span', [_vm._v("Both First and Second Testaments speak much about God’s eternality. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i",
    attrs: {
      "id": "p0026-07-9"
    }
  }, [_c('span', [_vm._v("Before the mountains were brought forth, or ever You had formed the earth and the world, even from everlasting to everlasting, You are God."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus5",
      "id": "car5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i",
    attrs: {
      "id": "p0026-08-10"
    }
  }, [_c('span', [_vm._v("To God our Savior, who alone is wise, be glory and majesty, dominion and power, both now and forever. Amen."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus6",
      "id": "car6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-09-11"
    }
  }, [_c('span', [_vm._v("It has been said that a student once asked Martin Luther, “What was God doing before He created the world?” Luther responded, “He went into the woods and cut rods with which to punish good-for-nothing "), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v(" questioners!” John Calvin reportedly responded to the same question: “God was not idle but was creating hell for curious questioners!”")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  })]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("While we respect Luther and Calvin, we don’t agree with those sentiments toward this question. What happened before God created the world is critical. And it is for that reason that the Scriptures are not silent on the matter. As Paul put it: “So we fix our eyes not on what is seen, but on what is unseen. For what is seen is temporary, but what is unseen is eternal.”"), _c('sup')])]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus7",
      "id": "car7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0027-05-7"
    }
  }, [_c('span', [_c('em', [_vm._v("Father, I want those you have given me to be with me where I am, and to see my glory, the glory you have given me because you loved me before the creation of the world.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-06-9"
    }
  }, [_c('span', [_vm._v("—J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESUS")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus8",
      "id": "car8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-04-4"
    }
  }, [_c('span', [_vm._v("What God was doing before creation belongs to the unseen and eternal. And Paul exhorted the Corinthians to fix their eyes on those eternal intangibles. In that connection, let’s explore what Jesus Christ was doing before the foundation of the world.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_02",
      "role": "doc-chapter",
      "title": "THE SON AND FATHER LOVED EACH OTHER"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "p0027-07-10"
    }
  }, [_c('span', [_vm._v("THE SON AND FATHER LOVED EACH OTHER ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0027-08-11"
    }
  }, [_c('span', [_vm._v("Before God the Father said, “Let there be light,”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus9",
      "id": "car9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" He loved His Son. Before time, the Father and the Son enjoyed a mutual exchange of love, life, and fellowship through the Spirit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus10",
      "id": "car10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" All throughout the Second Testament, we see Jesus returning to the Father what the Father has given Him."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus11",
      "id": "car11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" This reciprocal activity is rooted in His very nature of God Himself. His nature is love."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus12",
      "id": "car12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Thus, what Jesus did on earth, He did in His purely divine state as the eternal Son. The loving oneness the Father and the Son shared before time was reflected on the earth as well."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus13",
      "id": "car13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-09-12"
    }
  }, [_c('span', [_vm._v("This exchange of love, life, and fellowship is best understood in terms of the triune God."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus14",
      "id": "car14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" In the trinitarian community, the Father, Son, and Spirit all enjoy the fullness of one another in endless fellowship."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus15",
      "id": "car15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Each member loves the other. That is, the Father and Son both empty themselves and pour themselves into each other through the Spirit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus16",
      "id": "car16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" It is within this eternal fellowship that we find the headwaters of the mission of God, the church, and the believer’s life in Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus17",
      "id": "car17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v(" According to Philippians 2, the Son left the pristine setting of a shared love that flowed between the Father, Son, and Spirit, and made Himself of no reputation as a human being—even a servant."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus18",
      "id": "car18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" While on earth, Jesus divested Himself of His divine rights and was the recipient of the Father’s love, life, and power—just as He had known them in eternity.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-02-2"
    }
  }, [_c('span', [_vm._v("Consequently, the incarnation should not be seen as a single temporal act in history. But the divine emptying that it embodied began before creation, continued into the incarnation, and further than that. As Paul wrote, it continued to “even the death of the cross.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus19",
      "id": "car19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" In the incarnation, the God of eternity gave Himself to humanity by becoming human."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus20",
      "id": "car20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-03-3"
    }
  }, [_c('span', [_vm._v("Because we are caught in space-time, the incarnation is something we can approach only from the human side. We know it to be a historical event that took place in the first century. But when we talk about the incarnate Son—Emmanuel, God with us—we’re talking about a profound mystery. The incarnation points to an eternal reality. Namely, God’s nature is that of "), _c('em', [_vm._v("kenosis")]), _vm._v(", the pouring out of Himself in love into the other members of the Trinity. This pouring out of divine fullness was experienced between the members of the triune God before time."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus22",
      "id": "car22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" God the Father has always been the God who pours Himself into the Son. He has never been anyone else. And God the Son has always been the God who pours Himself into the Father. He has never been anyone else."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus23",
      "id": "car23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" When Jesus took on human flesh, the principle of incarnation broke into time and space.")])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0028-06-7"
    }
  }, [_c('span', [_c('em', [_vm._v("And now, Father, glorify me in your presence with the glory I had with you before the world began.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-07-9"
    }
  }, [_c('span', [_vm._v("—J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESUS")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus21",
      "id": "car21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-08-10"
    }
  }, [_c('span', [_vm._v("But that’s not all. Before time began, the Son of God lived by His Father’s life. This practice continued when He took on flesh and became a man. Jesus repeatedly said that it was not Him but His Father who did the works. It was not Him but His Father who gave the teachings. It was not Him but His Father who made the judgments. Jesus boldly declared that He could do nothing without the Father. And He lived by the Father’s life. But this was nothing new. It was true of Jesus in "), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v(" eternity. With the coming of Bethlehem, the key had switched from the divine to the human, but the song remained the same. The Father’s life was the source of the Son’s being and living—in eternity as well as on the earth."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus24",
      "id": "car24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" As one theologian put it, the Father is the Source, the Son is the Wellspring, and the Spirit is the Living Water."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus25",
      "id": "car25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_03",
      "role": "doc-chapter",
      "title": "THE SON AND FATHER SHARED THE DIVINE GLORY"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "p0029-02-1"
    }
  }, [_c('span', [_vm._v("THE SON AND FATHER SHARED THE DIVINE GLORY ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0029-03-2"
    }
  }, [_c('span', [_vm._v("Before God the Father ever said, “Let there be . . .”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus26",
      "id": "car26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" He shared His radiant glory with His Son. And His Son returned that glory back to the Father.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-04-4"
    }
  }, [_c('span', [_vm._v("God’s glory is not something separate from His Being. His glory is another way of talking about who He is. God’s glory is His own essential life, with all of the wonder and splendor of what it means to be God. The Hebrew word for glory is "), _c('em', [_vm._v("kavod")]), _vm._v(", and it means the essential weight of something. The very being of God is love,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus27",
      "id": "car27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" and that love is understood as the mutual sharing of glory with one another “before the world was.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus28",
      "id": "car28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-05-5"
    }
  }, [_c('span', [_vm._v("With the birth of Christ, the eternal broke into space and time. And one of the hallmarks of this inbreaking was "), _c('em', [_vm._v("glory")]), _vm._v(". The Lord Jesus left glory to come to a sin-cursed earth. In His High Priestly Prayer in John 17, Jesus recalled “the glory which I had with You before the world was.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus29",
      "id": "car29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" We can only put our hands over our mouths when it comes to articulating the "), _c('em', [_vm._v("glory ")]), _vm._v("that was shared between Father, Son, and Spirit before anything was made.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-06-7"
    }
  }, [_c('span', [_vm._v("But, thankfully, the Lord has given us numerous glimpses of His glory in the unfolding drama of history. We will just highlight a few. Keep in mind that these were appearances of Christ, who is “the radiance of His glory.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus30",
      "id": "car30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-07-8"
    }
  }, [_c('span', [_vm._v("The pictures, signs, and events that were given by God before Christ came to earth were not random. Hebrews 8:5 states that they were copies and shadows of what existed in heaven before anything was made. In other words, they were the pre-creation heavenly realities flowing out of the eternal Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus31",
      "id": "car31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v(" We know that Abraham encountered the eternal Christ. Jesus told His detractors, “Your father Abraham rejoiced at the thought of seeing my day; he saw it and was glad.” They responded by noting that Jesus was not even fifty—“How could you have seen Abraham?” Jesus gave them this astounding response: “Most assuredly, I say to you, before Abraham was born, I AM.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus32",
      "id": "car32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-02-1"
    }
  }, [_c('span', [_vm._v("Isaiah said, “In the year that King Uzziah died, I saw the Lord sitting on a throne, high and lifted up.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus33",
      "id": "car33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" When confronting the Jews’ unbelief, John noted, referring to Jesus, “Isaiah said this because he saw Jesus’ glory and spoke about him.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus34",
      "id": "car34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Thus when Isaiah “saw the Lord,” he was speaking of the eternal Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus35",
      "id": "car35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-03-2"
    }
  }, [_c('span', [_vm._v("After the exodus out of Egypt, God led Israel by His glory in a cloud."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus36",
      "id": "car36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Paul noted that the eternal Christ was the One who was guiding the people of God. He wrote that they “all ate the same spiritual food, and all drank the same spiritual drink. For they drank of that spiritual Rock that followed them, and that Rock was Christ.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus37",
      "id": "car37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" This literal rock pointed to the spiritual reality of Jesus Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus38",
      "id": "car38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-04-3"
    }
  }, [_c('span', [_vm._v("Recall that Moses asked God to show him His glory. The Lord put Moses in the cleft of a rock and covered him with His hand while His glory passed by. Then the hand of God was removed, and Moses saw God’s back but not His face, for God said, “You cannot see My face, for no man can see Me and live!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus39",
      "id": "car39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" That was then, but later, in the gospel age, Paul said that God made His light shine in our hearts “to give the light of the knowledge of the glory of God in the face of Jesus Christ.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus40",
      "id": "car40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" John said the same, writing, “No one has seen God at any time. The only begotten Son, who is in the bosom of the Father, He has declared Him.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus41",
      "id": "car41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-05-4"
    }
  }, [_c('span', [_vm._v("Jesus is the human face of God. He is also the inbreaking of the eternal into time. This is a good definition of the kingdom of God, which is embodied in Jesus.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-06-6"
    }
  }, [_c('span', [_vm._v("After Moses constructed the tabernacle according to the Lord’s directions, “the glory of the Lord filled the tabernacle.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus42",
      "id": "car42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" This was a picture of the Lord dwelling with His people. When Jesus appeared on earth, He “tabernacled” among us, and “we beheld His glory.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus43",
      "id": "car43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" He was the fulfillment of the earthly tabernacle and the glory that rested upon it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus44",
      "id": "car44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v(" Given the inexpressible glory that the Father, Son, and Spirit shared before time, and given the amazing and repetitive appearances of the glory of God in history, it is not surprising that the glory of God would explode in the person of the heavenly Man as He penetrated the earth through Mary’s womb. Shepherds beheld the glory at His birth.")]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus45",
      "id": "car45",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("45")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0031-03-2"
    }
  }, [_c('span', [_c('em', [_vm._v("To me, the very least of all saints, this grace was given, to preach to the Gentiles the unfathomable riches of Christ, and to bring to light what is the administration of the mystery which for ages has been hidden in God who created all things; so that the manifold wisdom of God might now be made known through the church to the rulers and the authorities in the heavenly places. This was in accordance with the eternal purpose which He carried out in Christ Jesus our Lord.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-P-2"
    }
  }, [_c('span', [_vm._v("—T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE APOSTLE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus49",
      "id": "car49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-05-5"
    }
  }, [_c('span', [_vm._v("John saw the coming of Christ stepping into history against the backdrop of the original Genesis account. “In the beginning was the Logos, and the Logos was with God, and the Logos was God. He was with God in the beginning.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus46",
      "id": "car46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" This One who had full, unabated glory with the Father before time had now entered the confines of time to fulfill the eternal purpose of the Godhead. And what was the chief attribute that captured their attention? “We beheld His "), _c('em', [_vm._v("glory")]), _vm._v(".” The glory from above was now functioning on earth. However, before Calvary it was a "), _c('em', [_vm._v("veiled ")]), _vm._v("glory.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-06-8"
    }
  }, [_c('span', [_vm._v("Luke noted that he and the other apostles “saw His glory” on the Mount of Transfiguration."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus47",
      "id": "car47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" But then something beyond remarkable happened: “a cloud appeared and enveloped them, and they were afraid as they entered the cloud.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus48",
      "id": "car48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" This cloud is reminiscent of the cloud that led Israel, came upon the tabernacle of Moses, and filled ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-P-4"
    }
  }, [_c('span', [_vm._v("Solomon’s temple. It was the cloud of God’s shekinah glory of His awesome presence. Out of this cloud the Lord spoke with clarity, “This is My beloved Son. Hear Him!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus50",
      "id": "car50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-08-10"
    }
  }, [_c('span', [_vm._v("Glory is the highest expression of a life. When a flower is in full "), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v(" bloom, we say it is glorified."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus51",
      "id": "car51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" When God’s divine, uncreated life is at its highest expression, Scripture calls it "), _c('em', [_vm._v("glory")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus52",
      "id": "car52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-02-1"
    }
  }, [_c('span', [_vm._v("Jesus is the mercy seat."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus53",
      "id": "car53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" He is the dwelling place of God and the Sin-Bearer. Christ is the fulfillment of all that was signified in the space between the cherubim."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus54",
      "id": "car54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-03-2"
    }
  }, [_c('span', [_vm._v("In the end, we are given a spellbinding look at the heavenly city, the New Jerusalem, which comes down out of heaven from God. The city shines with the glory of God."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus55",
      "id": "car55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Next, we see the glory of God filling the new heaven and new earth: “I did not see a temple in the city, because the Lord God Almighty and the Lamb are its temple. The city does not need the sun or the moon to shine on it, for the glory of God gives it light, and the Lamb is its lamp.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus56",
      "id": "car56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" The glory that humanity lost at the Fall has been restored."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus57",
      "id": "car57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_04",
      "role": "doc-chapter",
      "title": "THE GODHEAD BIRTHED AN ETERNAL PURPOSE AND SHROUDED IT IN A MYSTERY"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "p0032-04-3"
    }
  }, [_c('span', [_vm._v("THE GODHEAD BIRTHED AN ETERNAL "), _c('br'), _vm._v(" PURPOSE AND SHROUDED IT IN A MYSTERY ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0032-05-4"
    }
  }, [_c('span', [_vm._v("Before creation, the Godhead conceived of an eternal purpose. They shrouded that purpose as a mystery in Christ, where it was hid in God for ages. An entire book could be written unveiling God’s eternal purpose."), _c('span', {
    attrs: {
      "href": "#/chapter22#bus58",
      "id": "car58",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("58")])]), _vm._v(" But we will summarize it briefly. Before time, the Father, Son, and Spirit counseled together and purposed to expand the fellowship they had with one another. This was the very reason that provoked creation. God wanted to enlarge the love relationship between the Father and the Son through the Spirit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus59",
      "id": "car59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" In the words of C. S. Lewis, “The whole dance, or drama, or pattern of this three-Personal life is to be played out in each one of us.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus60",
      "id": "car60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-06-5"
    }
  }, [_c('span', [_vm._v("History is not about whim and chance. It is the unfolding of God’s timeless purpose in Christ. Paul saw that the creation was designed for the formation of a bride and a body for the Son."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus61",
      "id": "car61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" With everything being by the Son, for the Son, and to the Son, the perfect eternal communion of the triune God would be expanded through history into a vast, uncountable number of saints (“holy ones”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus62",
      "id": "car62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(") from all over the earth.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0032-07-7"
    }
  }, [_c('span', [_vm._v("To this end, the church is said to be chosen in Christ “before the foundation of the world.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus63",
      "id": "car63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" This bride and body constitute the family of "), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v(" God and a dwelling place for the Father through the Spirit."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus64",
      "id": "car64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" Therefore, God the Father desired children. He also desired a home through which to express His glory. The Son desired a bride to be His counterpart and enter the divine dance that existed eternally between the Father, Son, and Spirit. She would be the new partner in the dance. The bride would also be the body for the Son’s visible expression and movement in a created world. These four aspects of the eternal purpose—a bride, a body, a family, and a house—are all highlighted in Paul’s letter called Ephesians. And they can be found from Genesis 1 to Revelation 22. (This point will be explained further in chapters 2 and 3.)")])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0033-04-5"
    }
  }, [_c('span', [_c('em', [_vm._v("His works were finished from the foundation of the world.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "P0033-04-6"
    }
  }, [_c('span', [_vm._v("—T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE APOSTLE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus65",
      "id": "car65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_05",
      "role": "doc-chapter",
      "title": "GOD FINISHED ALL THINGS BEFORE HE BEGAN ALL THINGS"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "p0033-05-7"
    }
  }, [_c('span', [_vm._v("GOD FINISHED ALL THINGS BEFORE "), _c('br'), _vm._v(" HE BEGAN ALL THINGS ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0033-06-8"
    }
  }, [_c('span', [_vm._v("Jesus Christ had finished all things before He created all things. This is perhaps one of the most glorious things Jesus Christ accomplished before creation, but it may be the least reflected upon. Imagine a builder standing in front of an empty lot, saying, “What a beautiful house I have constructed.” But there is nothing there. Only the Lord can say that His plans in the Son were finished in eternity before they came to pass in history. He completed the masterpiece before He ever painted it.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-07-10"
    }
  }, [_c('span', [_vm._v("How can this be? It is because time exists in Christ. Paul told us that in Christ, “all things hold together.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus66",
      "id": "car66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" That includes creation itself, which includes time."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus67",
      "id": "car67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" C. S. Lewis drew a brilliant illustration to describe this reality. He said to imagine a straight line on a piece of paper. The line is time. The paper is God Himself. Time is in God just as the line is in the paper. Consequently, He is at the beginning"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus68",
      "id": "car68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" and the end at the same time."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus69",
      "id": "car69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" As one theologian put it, “God is immediately and simultaneously aware of all events. Whether they be in what we call ’past,’ ’present,’ or ’future,’ they are all in God’s ’present.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus70",
      "id": "car70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v(" This throws fresh light on the declarations in Revelation that Jesus Christ is the Beginning and the End, the Alpha and the Omega, and First and the Last."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus71",
      "id": "car71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" It’s not that Christ was first the Alpha and then later the Omega. It’s that Christ is the Alpha and Omega, the Beginning and the End, at the same moment. How? Because the line of time exists within Him.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-02-2"
    }
  }, [_c('span', [_vm._v("Recall when Jesus said to the Pharisees, “Where I am you cannot come.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus72",
      "id": "car72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Notice He didn’t say, “where I am going,” but “where I am.” Jesus couldn’t have said that unless time was in Him. Christ is the great I AM, the self-existent One, the One “who is and who was and who is to come” all at once."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus73",
      "id": "car73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" According to John, Jesus used the divine formula “I AM” without the predicate:"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus74",
      "id": "car74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i",
    attrs: {
      "id": "p0034-03-3"
    }
  }, [_c('span', [_vm._v("“For if you do not believe that I am He [I AM], you will die in your sins.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus75",
      "id": "car75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i"
  }, [_c('span', [_vm._v("“When you lift up the Son of Man, then you will know that I am He [I AM].”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus76",
      "id": "car76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i"
  }, [_c('span', [_vm._v("“Before Abraham was, I AM.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus77",
      "id": "car77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i"
  }, [_c('span', [_vm._v("“Now I tell you before it comes, that when it does come to pass, you may believe that I am He [I AM].”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus78",
      "id": "car78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0034-04-4"
    }
  }, [_c('span', [_vm._v("It is no wonder the prophets declared that the Messiah would be the Root (the beginning) and the Branch (the end) at the same time,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus79",
      "id": "car79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" the Root and the Offspring of David."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus80",
      "id": "car80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-05-5"
    }
  }, [_c('span', [_vm._v("For this reason, Paul saw God’s purpose as both unfolding before his eyes "), _c('em', [_vm._v("and ")]), _vm._v("as already completed before the world began: “[Those] whom He predestined, these He also called; whom He called, these He also justified; and whom He justified, these He also glorified.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus81",
      "id": "car81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-06-6"
    }
  }, [_c('span', [_vm._v("This is a remarkable statement. In God’s reality, we are already glorified. As creatures caught in space and time, our glorification hasn’t caught up to us yet. But it has already been accomplished."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus82",
      "id": "car82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-07-7"
    }
  }, [_c('span', [_vm._v("It’s not that God shot the movie in His head before He put it on "), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v(" film. It’s that the movie exists inside of Him and He’s at the beginning, the middle, and the end all at the same time. In other words, the Lord is not playing it by ear. He is not improvising and making it up as He goes along. No matter how chaotic things may seem, God has already worked the chaos into His plan and has turned it into good."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus83",
      "id": "car83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")]), _vm._v(" In fact, Jesus’ own death was not an afterthought. Death was His destiny before the foundation of the world. Before lambs were ever created, a Lamb was slain. He is the “Lamb slain from the foundation of the world.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus84",
      "id": "car84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" This reminds us of the “everlasting covenant” of which Hebrews 13:20 speaks."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus85",
      "id": "car85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txa",
    attrs: {
      "id": "p0035-02-1"
    }
  }, [_c('span', [_vm._v("But that’s not all. Consider what else God did before creation:")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', [_vm._v("• He decided His eternal counsel and purpose before it actually happened."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus86",
      "id": "car86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', [_vm._v("• He chose us before the foundation of the world, calling us with a holy calling before the world began."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus87",
      "id": "car87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', [_vm._v("• He wrote our names in the Lamb’s Book of Life before the foundation of the world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus88",
      "id": "car88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', [_vm._v("• Before the first angel came off of the finger of God, and before He uttered the words “Let there be . . .”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus89",
      "id": "car89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" He gave us the promise of eternal life and a great inheritance in the Son."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus90",
      "id": "car90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', [_vm._v("• The very things He would utter while He was on earth were kept secret before the world began."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus91",
      "id": "car91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txb",
    attrs: {
      "id": "p0035-04-4"
    }
  }, [_c('span', [_vm._v("All of this is good news, even amazing news. Your salvation was established, completed, and sealed before creation itself. Your Lord wrapped it up, won it, and came out victorious before anything ever went wrong. Before creation, Jesus Christ foreknew you, chose you, predestined you, elected you, selected you, and inherited you to be His."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus92",
      "id": "car92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-05-5"
    }
  }, [_c('span', [_vm._v("Consider what limits your Lord went to in accomplishing His eternal purpose. Herein do we find the epic greatness and enormity of Jesus Christ. As we put it in "), _c('em', [_vm._v("Jesus Manifesto")]), _vm._v(","), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus93",
      "id": "car93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" He is so much more than Lord and Savior.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-06-7"
    }
  }, [_c('span', [_vm._v("The truth is, the "), _c('em', [_vm._v("new creation ")]), _vm._v("began in eternity before the old creation was made. All of this was a secret—a mystery hidden in God. But in the fullness of time, Jesus Christ appeared, and the mystery began "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v(" to be unraveled. A central dimension of Paul’s service was “to bring to light what is the administration of the mystery which for ages has been hidden in God who created all things.”")]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus94",
      "id": "car94",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("94")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-02-1"
    }
  }, [_c('span', [_vm._v("What is at the beginning? "), _c('em', [_vm._v("Christ. ")]), _vm._v("What is at the end? "), _c('em', [_vm._v("Christ. ")]), _vm._v("Both ends of the bottle of time are capped off by Jesus. He is the beginning, and at the same time He is the end. He envelops creation; He envelops time. In Him, everything occurs and is summed up.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_06",
      "role": "doc-chapter",
      "title": "THE ETERNAL CROSS"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "P0036-03-3"
    }
  }, [_c('span', [_vm._v("THE ETERNAL CROSS ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0036-04-4"
    }
  }, [_c('span', [_vm._v("A Lamb was slain on the cross from the creation of the world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus95",
      "id": "car95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" That eternal cross reached before creation and extended after creation. It broke into the visible creation in "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("AD")]), _vm._v(" 30 on a hill called Calvary, but it existed before the ticking of time. By that cross, Jesus the Christ reconciled a fallen universe to Himself."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus96",
      "id": "car96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" After His death, His body was laid in an empty tomb for three days. And on the third day, God raised Him from the dead."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus97",
      "id": "car97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" And the only things that came out of the other side of that cross and that empty tomb were Christ Himself and everything that was in Christ before the foundation of the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-05-6"
    }
  }, [_c('span', [_vm._v("Everything else died and was destroyed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-06-8"
    }
  }, [_c('span', [_vm._v("Through the eternal cross, Jesus Christ finished all things before He created all things.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-07-10"
    }
  }, [_c('span', [_vm._v("What did He finish? He finished the old creation and the Fall. He finished sin. He finished a fallen world system. He finished the enmity of the Law. He finished satan. He finished the flesh. He put you to death and finished you completely. The person you were in Adam was terminated, swallowed up in death. And then He finished His greatest enemy, the child of sin itself, death. If that isn’t enough, He did something else beyond the rest: "), _c('em', [_vm._v("He raised you up in resurrection life and glorified you.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-08-12"
    }
  }, [_c('span', [_vm._v("All of this flows from the mystery embedded in eternity past, a mystery that Paul of Tarsus declared to be his “gospel”:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i",
    attrs: {
      "id": "p0036-09-14"
    }
  }, [_c('span', [_vm._v("Now to him who is able to establish you by my gospel and the proclamation of Jesus Christ, according to the revelation of the mystery hidden for long ages past, but now revealed and made known through "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("the prophetic writings by the command of the eternal God, so that all nations might believe and obey him—to the only wise God be glory forever through Jesus Christ! Amen.")]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus98",
      "id": "car98",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("98")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0037-02-1"
    }
  }, [_c('span', [_vm._v("God has never had any plans outside of His Son. As the ancient creed says, “Before all worlds” Christ is begotten, not created."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus99",
      "id": "car99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" Jesus Christ was before all things. He created all things. He holds everything together. He will have preeminence in everything,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus100",
      "id": "car100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" for everything will be summed up in Him."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus101",
      "id": "car101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" Christ is the firstborn of all creation and the firstborn from the dead, that He might have the first place in all things."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus102",
      "id": "car102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" No wonder Thomas said to the resurrected Jesus, “My Lord and my God!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus103",
      "id": "car103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0037-04-4"
    }
  }, [_c('span', [_c('em', [_vm._v("Divine fullness is only going to be reached by a progressive and ever-increasing revelation of Christ and His significance.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "P0037-05-6"
    }
  }, [_c('span', [_vm._v("—T. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USTIN")]), _vm._v("-S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PARKS")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus104",
      "id": "car104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_07",
      "role": "doc-chapter",
      "title": "THE PREEXISTENT LOGOS"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "P0037-06-7"
    }
  }, [_c('span', [_vm._v("THE PREEXISTENT LOGOS ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0037-07-8"
    }
  }, [_c('span', [_vm._v("We will close this chapter with a few thoughts about the Logos, mentioned in John’s gospel. The Greek word "), _c('em', [_vm._v("logos ")]), _vm._v("has a long history of meaning in the Greek and Jewish worlds. Beginning with Heraclitus in the sixth century BC, the word "), _c('em', [_vm._v("logos ")]), _vm._v("meant the principle that gave the universe order, meaning, structure, and harmony. Aristotle used the term to mean reasoned discourse. Other Greek philosophers believed "), _c('em', [_vm._v("logos ")]), _vm._v("to be the divine, active reason that animated the created universe. The word has been translated into “word,” “speech,” “reason,” “principle,” “language,” “logic,” and “story.” The Jewish philosopher Philo believed the "), _c('em', [_vm._v("logos ")]), _vm._v("to be the bond of everything that held all created things together. He taught that the "), _c('em', [_vm._v("logos ")]), _vm._v("acted on behalf of God and was His instrument in creating the universe.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0037-08-10"
    }
  }, [_c('span', [_vm._v("With all of this as a backdrop, John came along and announced that the Logos was God, the Logos was with God, and the Logos created all things."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus105",
      "id": "car105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" But the mind-blowing statement with which John followed this up is, the Logos took on human flesh and became a man dwelling among us!"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus106",
      "id": "car106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v(" The Logos is Jesus of Nazareth. He is the speaking Word—God enfleshed.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0038-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("The Logos is also associated with God’s wisdom. Proverbs 8:22–31 depicts a divine wisdom speaking in the first person as being in existence in eternity, before creation. Jeremiah says that God established the earth by His wisdom and His power.")])]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus107",
      "id": "car107",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("107")])]), _vm._v(" The psalmist wrote that “by the word [Greek, "), _c('em', [_vm._v("logos")]), _vm._v("] of the Lord the heavens were made, and by the breath of his mouth all their host.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus108",
      "id": "car108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Paul taught that Jesus Christ is the wisdom of God and the power of God."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus109",
      "id": "car109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" This wisdom, or self-expression, ordered and harmonized the universe."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus110",
      "id": "car110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0038-03-3"
    }
  }, [_c('span', [_vm._v("Consequently, the Logos brought together Hebrew ideas of creation and Greek ideas of a universal harmony. It is the Creator’s self-expression that harmonized the universe. What John brought in his gospel was not a new idea, but a new fact: this divine self-expression that harmonizes the universe is an actual human being. And neither Hebrew nor Greek could grasp that.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0038-04-5"
    }
  }, [_c('span', [_vm._v("We agree with Lutheran theologian Robert Jensen that Christ as the Logos should be seen not just as God’s revelation of Himself to us but as God’s own self-knowledge."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus111",
      "id": "car111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" And as we borrow from Augustine and the Eastern fathers, God knows who He is through being Father to the Son. Thus Jesus is God’s own knowledge of Himself. Therefore, everything that makes up divine revelation in the First Testament is part of that self-knowledge.")])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0038-07-9"
    }
  }, [_c('span', [_c('em', [_vm._v("God dwells in eternity but time dwells in God. He has already lived all our tomorrows as He has lived all our yesterdays.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "P0038-08-12"
    }
  }, [_c('span', [_vm._v("—A.W. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OZER")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus112",
      "id": "car112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txlla"
  }, [_c('span', [_vm._v("..............................................")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0038-P-2"
    }
  }, [_c('span', [_vm._v("When that self-knowledge becomes incarnate in the flesh of the man Jesus, then the entire content of the First Testament revelation is included in the incarnate Son. In God, the duality between movement and eternity is overcome. God is both eternal and eternally moving. Theirs is a consistent "), _c('em', [_vm._v("kenosis ")]), _vm._v("(self-emptying) of each member of the Trinity into the others. The constant total surrender of Father, Son, and Spirit to one another is the life of God. This eternal, divine life is an eternal movement. From another perspective, Jesus is the space and "), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("time in which humanity gets caught up into the movement of God. Thus God’s movement becomes a movement of the divine and the human in Jesus. Jesus, therefore, is the movement of the incarnation. In short, Jesus is God’s self-understanding enfleshed. God knows Himself to be what He is when He sees the Son.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0039-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("In Colossians 1:15, Paul called Jesus “the firstborn over all creation.” This indicates two things: First, Christ existed before creation. He was there before anything came into existence. Second, Jesus has primacy over creation, being the heir to all created things.")])]), _c('span', {
    attrs: {
      "href": "#/chapter22#bus113",
      "id": "car113",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("113")])]), _vm._v(" As Hebrews puts it, Christ was “appointed heir of all things, through whom also He made the worlds.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus114",
      "id": "car114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" Jesus is both the source and the sustainer of creation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#bus115",
      "id": "car115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0039-03-3"
    }
  }, [_c('span', [_vm._v("A separate volume could be written on the preincarnate Christ. In this chapter, we simply wanted to give you a glimpse of the biblical witness on the matter. Let’s now shift gears and look at how the creation account in Genesis 1 and 2 also narrates the Jesus story.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbc6f20e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 78
// module chunks = 0